<template>
    <div style="width: 100%;">
        <div class="title">{{$t('申请信息')}}</div>
        <table class="custom-table-panel"
               cellpadding="0"
               cellspacing="0"
               style="width:100%">
            <tr>
                <th>{{$t('文件系统')}}{{$t('名称')}}</th>
                <th>{{$t('实例名称')}}</th>
                <th>{{$t('用户')}}</th>
                <th>{{$t('GID')}}</th>
                <th>{{$t('UID')}}</th>
                <th>{{$t('配额')}}</th>
                <th>{{$t('单位')}}</th>
            </tr>
            <tbody>
                <tr v-for="quota in quotas"
                    :key="quota.key">
                    <td>{{quota.shareList.length ? getName(quota.shareList[0].label,0) : '--'}}</td>
                    <td>{{quota.shareList.length ? getName(quota.shareList[0].label,1) : '--'}}</td>
                    <td>{{quota.userList.length ? quota.userList[0].label : '--'}}</td>
                    <td>{{quota.gid || '--'}}</td>
                    <td>{{quota.uid || '--'}}</td>
                    <td>{{quota.quota || '--'}}</td>
                    <td>{{quota.unit || '--'}}</td>
                </tr>
                <tr v-if="!quotas.length">
                    <td colspan="7"
                        class="no-data">{{$t('暂无数据')}}</td>
                </tr>
            </tbody>
        </table>
        <div class="title">{{$t('流程处理')}}</div>
        <ul class="approve-inf">
            <li>
                <span class="label">{{$t('处理')}}:</span>
                <span>{{approveTypeNames[information.approveType]||'--'}}</span>
            </li>
            <li>
                <span class="label">{{$t('处理意见')}}:</span>
                <span style="max-width: 600px;">{{information.approveAdvice||'--'}}</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'QuotaApplication',
    components: {
    },
    props: {
        information: {}
    },
    data () {
        return {
            approveTypeNames: {
                '01': '通过',
                '02': '驳回',
                '03': '拒绝并关闭'
            }
        }
    },
    computed: {
        quotas () {
            const { panelDataList } = JSON.parse(this.information.templateContent || '{}')
            return panelDataList || []
        }
    },
    created () {
    },
    methods: {
        getName (v = '', index) {
            const texts = v.replace(/）/g, '').split('（')
            if (texts.length === 1) {
                return !index ? '--' : texts[0] || '--'
            }
            return texts[index] || '--'
        }
    }
}
</script>

<style lang="less" scoped>
.approve-inf {
    li {
        display: flex;
        padding: 6px 0;
        .label {
            display: inline-block;
            width: 90px;
            text-align: right;
            padding-right: 15px;
            color: #808080;
            flex-shrink: 0;
        }
    }
}
.title {
    height: 40px;
    font-size: 12px;
    line-height: 40px;
    font-weight: bold;
    color: #000;
    border-bottom: 1px dashed #e9e9e9;
    margin-bottom: 15px;
}
.custom-table-panel {
    // border: 1px solid #e9e9e9;
    // max-width: 1000px;
    width: 100%;
    min-width: 500px;
    tr {
    }
    th,
    td {
        padding: 4px 8px;
        height: 42px;
        .td-txt {
            display: block;
            margin-bottom: 8px;
            white-space: nowrap;
        }
    }
    th {
        background-color: #f0f2f3;
        text-align: left;
        border-right: 1px solid #e9e9e9;
        white-space: nowrap;
        font-weight: 500;
        font-size: 14px;
    }
    .no-data {
        text-align: center;
        line-height: 50px;
        background: #fff;
        color: #808080;
    }
}
</style>
